// Ticket 2 — "How did you hear about AidFone?" optional signup survey.
// These stable option keys are what get stored in caregivers.referral_source;
// the human labels are i18n (deploymentSignup.referralOptions.<key>). Keep the
// keys stable so the column stays safe to GROUP BY for attribution reporting.
// FR labels are DRAFT pending Normand's FR pack (see DEV sheet Ticket 2).
export const REFERRAL_SOURCE_OPTIONS = [
  'google',
  'ai_assistant',
  'facebook',
  'instagram',
  'tiktok',
  'youtube',
  'friend_family',
  'news_article',
  'other',
] as const;

export type ReferralSource = (typeof REFERRAL_SOURCE_OPTIONS)[number];
